// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-landing-page -> mox-theme-landing-page -> the-six-eight-lp
// Generated: 2026-10-16T17:34:00.398Z
// Counts: 0 design, 6 content, 2 slot group, 2 collection binding, 3 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "hero.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "multihub-lead-capture.lead_source": {
    "overrideType": "VALUE",
    "customValue": "LANDING_PAGE",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=160/company/5767906449162466/01a01059-a5e2-7667-9dee-e75a334c3f2a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.description": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Start with the map, then step into it.</strong> Around THE'68 at Hemisfair, Hemisfair feels less like a landmark and more like your everyday route—morning coffee at Box St. All Day, Neapolitan pizza at Dough, a glass at Re:Rooted 210, or a scoop from Lick Honest Ice Creams just beyond the lobby.</p><p>Civic Park brings the neighborhood’s rhythm into focus with the Great Lawn, The Springs, and a Mexican Sycamore-lined promenade that connects to Yanaguana Garden and points you toward downtown, Southtown, and the River Walk. Public art, shaded paths, patios, festivals, and quick bites give each block a reason to linger. Explore the map, then <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to see how this Hemisfair address puts San Antonio’s park-district energy right outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Modern downtown apartments in the heart of Hemisfair.</strong> Explore studio, one-, and two-bedroom <a class=\"richtext-link\" href=\"/floor-plans\">floor plans</a> with city-framing windows, polished finishes, and access to standout shared spaces—then <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to see THE'68 at Hemisfair up close.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "header.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_medium=ppc&utm_source=google&utm_campaign=landing-page"
      }
    }
  },
  "hero.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "neighborhoodmap.pois": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "ga4-tracking",
      "blockId": "ga4-tracking",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
